import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./router/AuthContext";
import AppRouter from "./router/Router";
import "./index.css";
import { SnackbarProvider } from "notistack";
import { SkeletonTheme } from "react-loading-skeleton";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <div
          className="light hide-scrollbar"
          style={{
            background: "#FFFFFF",
          }}
        >
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <SkeletonTheme baseColor="#ECECEC" highlightColor="#F7F7F7">
              <AppRouter />
            </SkeletonTheme>
          </SnackbarProvider>
        </div>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
